import React, { useState, useEffect, useReducer } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { CTA_STATUS_ACTIVE, CTA_STATUS_INACTIVE } from '../../../constants/UiBuilderConst';

const CTASelector = (props) => {
  const {
    onValueChange,
    value,
    onCTAStatusChange,
    isActive,
    error,
    areButtonsDisabled,
    isLabelDisabled,
    redirectAndCtaOneName,
  } = props;

  const [statusValue, setStatusValue] = useState(
    isActive ? CTA_STATUS_ACTIVE : CTA_STATUS_INACTIVE,
  );

  useEffect(() => {
    setStatusValue(isActive ? CTA_STATUS_ACTIVE : CTA_STATUS_INACTIVE);
  }, [isActive]);

  useEffect(() => {
    onCTAStatusChange(statusValue === CTA_STATUS_ACTIVE);
  }, [statusValue]);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    ctaTitle: {
      value: '',
      fieldName: 'CTA Title',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    const currFields = { ...formData };
    currFields.ctaTitle.value = value;
    formData.ctaTitle.validations = isActive ? ['required'] : [];
    currFields.ctaTitle.errors = error
      ? { required: `${currFields.ctaTitle.fieldName} is required` }
      : {};
    setFormData(currFields);
  }, [value, error]);

  useEffect(() => {
    onValueChange(formData.ctaTitle.value);
  }, [formData.ctaTitle.value]);

  const onStatusChange = (e) => {
    formData.ctaTitle.validations = e.target.value === CTA_STATUS_ACTIVE ? ['required'] : [];
    setStatusValue(e.target.value);
    const ctaTitle = { ...formData.ctaTitle };
    ctaTitle.validations = e.target.value === 'cta_status_active' ? ['required'] : [];
    setFormData({ ctaTitle });
  };

  return (
    <>
      <div className='col-md-12 redirect-selector mb-3'>
        <div className='row align-items-center mb-2 mt-3'>
          {!isLabelDisabled && <div className='col-md-4 title'>CTA</div>}
          {redirectAndCtaOneName && <div className='col-md-4 title'>{redirectAndCtaOneName}</div>}
          {!areButtonsDisabled && (
            <div className='col-md-8'>
              <RadioGroup
                row
                aria-label='statusValue'
                onChange={onStatusChange}
                value={statusValue}
                className='document-type'
                name='row-radio-buttons-group'
              >
                <FormControlLabel
                  value={CTA_STATUS_ACTIVE}
                  control={<Radio color='primary' />}
                  label='Active'
                  className='me-5'
                />
                <FormControlLabel
                  value={CTA_STATUS_INACTIVE}
                  control={<Radio color='primary' />}
                  label='Inactive'
                />
              </RadioGroup>
            </div>
          )}
        </div>
        {statusValue === CTA_STATUS_ACTIVE && (
          <div className='col-md-10'>
            <CustomTextField
              item={formData.ctaTitle}
              handleInputChange={(e) => {
                setFormData({ ctaTitle: e });
              }}
              maxLength={30}
              endAdornment={true}
              characterCount={true}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CTASelector;
